import { Box } from "@material-ui/core";
import React, { useEffect } from "react";
import { fakeFormsDataKYCAutomatic } from "../../../../../utils/fakeFormsData";
import BackButton from "../../../../shared/components/BackButton";
import { STEP_GROUP_IDS } from "../../../../shared/config";
import AdditionalData from "../../shared/AdditionalData/AdditionalData";
import { useStepHandler } from "../../../../../utils/hooks/useStepHandler";
import KycElectronicID from "../shared/steps/KycElectronicId";
import { KYC_AUTOMATIC } from "../shared/config";
import { useKycAutomatic } from "../shared/hooks/useKycAutomatic";
import RetryElectronicId from "../shared/components/RetryElectronicId";

export const KycAutomatic = (props) => {
  const {
    disableMaritalRegime,
    disableKycManual,
    disableOthers,
    allowInternationalBorrower,
  } = props;

  const STEP_GROUP_STEPS_ARRAY = [
    {
      id: KYC_AUTOMATIC.ADDITIONAL_DATA_GROUP,
      show: () => true,
      isGroup: true,
    },
  ];

  const CURRENT_STEP_GROUP = STEP_GROUP_IDS.KycAutomatic;

  const {
    electronicIDPassed,
    nieEu,
    onSubmitModule,
    onKoStep,
    onElectronicIDOk,
    onRetryElectronicId,
  } = useKycAutomatic({ disableMaritalRegime });

  const currentModuleStepHandler = useStepHandler(
    onSubmitModule,
    fakeFormsDataKYCAutomatic
  );

  const { manageGroup, onBack, backButtonVisible } = currentModuleStepHandler;

  useEffect(() => {
    if (electronicIDPassed) {
      manageGroup(CURRENT_STEP_GROUP, STEP_GROUP_STEPS_ARRAY);
    }
  }, [electronicIDPassed]);

  return (
    <>
      <Box className="appear-anim" style={{ position: "absolute" }}>
        <BackButton onBack={onBack} show={backButtonVisible} />
      </Box>
      {!electronicIDPassed && (
        <KycElectronicID
          onSubmitForm={onElectronicIDOk}
          onKoStep={onKoStep}
          disableKycManual={disableKycManual}
          allowInternationalBorrower={allowInternationalBorrower}
        />
      )}
      {electronicIDPassed && (
        <AdditionalData
          showNieEuFunc={() => nieEu}
          currentModuleStepHandler={currentModuleStepHandler}
          disableMaritalRegime={disableMaritalRegime}
          disableOthers={disableOthers}
        />
      )}
      <RetryElectronicId onRetryElectronicId={onRetryElectronicId} />
    </>
  );
};
